import { stringHelper } from 'helpers/string'

const storageService = {
  get,
  set,
  remove,
  update,
  clear
}

export const STORE_KEY = {
  RECHECK_CONTRACT: 'recheck_contract',
  TIME_REMIND_INCOME: 'time_remind_income',
  USER_LOGIN: 'user_login',
  TEACHER_BANNER: 'teacher_banner',
  CHECK_HAS_BOOKING_TEACHER_SESSION: 'check-has-booking-teacher-session',
  CONSIDERING_NUMBERS: 'considering_numbers',
}

function get (key) {
  const dataSession = sessionStorage.getItem(key)
  const dataLocal = localStorage.getItem(key)
  let data = dataSession || (dataLocal || null)
  if (data && stringHelper.isJsonString(data)) {
    data = JSON.parse(data)
  }
  return data
}

function set (key, data, remember = true) {
  if (remember) {
    localStorage.setItem(key, JSON.stringify(data))
  } else {
    sessionStorage.setItem(key, JSON.stringify(data))
  }
}

function remove (key) {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}

function update (key, field, value) {
  const data = this.get(key)
  data[field] = value
  const remember = !!localStorage.getItem(key)
  this.set(key, data, remember)
}

function clear() {
  const ignoreKeys = [
    STORE_KEY.USER_LOGIN,
  ]
  Object.values(STORE_KEY).forEach((key) => {
    if (ignoreKeys?.includes(key)) return
    remove(key)
  })
}

export default storageService
